module.exports = __webpack_public_path__ + "static/media/40-15-min.c946af88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imageSlider/40-15-min.jpg
// module id = 1406
// module chunks = 0